module.exports = __webpack_public_path__ + "img/ctrl-magic-stub-up-0.3731fa5d.svg";